var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" edit value "),_c('v-text-field',{attrs:{"type":"number"},model:{value:(_vm.localValue.value),callback:function ($$v) {_vm.$set(_vm.localValue, "value", $$v)},expression:"localValue.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }